<template>
  <el-card v-loading="loading">
    <el-descriptions title="表头" border>
      <el-descriptions-item :span="4" label="账册号">{{
        info.emsNo
      }}</el-descriptions-item>
      <el-descriptions-item label="核注业务单号">{{
        info.copListNo
      }}</el-descriptions-item>
      <el-descriptions-item label="核注清单号">{{
        info.businessId
      }}</el-descriptions-item>
      <el-descriptions-item label="单一窗口单号">{{
        info.singleWindowNo
      }}</el-descriptions-item>
      <el-descriptions-item label="经营企业编号">{{
        info.bizOpCompanyCode
      }}</el-descriptions-item>
      <el-descriptions-item label="经营企业社会信用代码">{{
        info.bizOpCompanyCreditNo
      }}</el-descriptions-item>
      <el-descriptions-item label="经营企业名称">{{
        info.bizOpCompanyName
      }}</el-descriptions-item>
      <el-descriptions-item label="收货企业编号">{{
        info.rcvCompanyCode
      }}</el-descriptions-item>
      <el-descriptions-item label="收货企业社会信用代码">{{
        info.rcvCompanyCreditNo
      }}</el-descriptions-item>
      <el-descriptions-item label="收货企业名称">{{
        info.rcvCompanyName
      }}</el-descriptions-item>
      <el-descriptions-item label="申报企业编号">{{
        info.dclCompanyCode
      }}</el-descriptions-item>
      <el-descriptions-item label="申报企业社会信用代码">{{
        info.dclCompanyCreditNo
      }}</el-descriptions-item>
      <el-descriptions-item label="申报企业名称">{{
        info.dclCompanyName
      }}</el-descriptions-item>
    </el-descriptions>
    <el-descriptions title="表体" style="margin-top: 20px;"></el-descriptions>
    <element-table
      :maxHeight="650"
      :data="info.items"
      :columns="itemColumns"
      :loading="loading"
      border
    ></element-table>
    <el-descriptions
      title="相关单证"
      style="margin-top: 20px;"
    ></el-descriptions>
    <div style="width: 650px;">
      <element-table
        :maxHeight="650"
        :data="info.bills"
        :columns="billColumns"
        :loading="loading"
        border
      ></element-table>
    </div>
  </el-card>
</template>

<script>
import ElementTable from "@/components/ElementTable";
import heZhuApi from "@/api/heZhuApi";
export default {
  components: {
    ElementTable
  },
  data() {
    return {
      heZhuOrderId: this.$route.params.id,
      loading: false,
      info: {},
      itemColumns: [
        {
          title: "商品序号",
          key: "listGNo",
          minWidth: 80,
          align: "center"
        },
        {
          title: "备案序号",
          key: "gno",
          minWidth: 80,
          align: "center"
        },
        {
          title: "HSCODE",
          key: "codeTs",
          align: "center",
          minWidth: 100
        },
        {
          title: "商品料号",
          key: "copGNo",
          align: "center",
          minWidth: 180
        },
        {
          title: "商品名称",
          key: "gName",
          align: "center",
          minWidth: 250
        },
        {
          title: "商品规格型号",
          key: "gModel",
          align: "center",
          minWidth: 300
        },
        {
          title: "申报计量单位",
          key: "unit",
          minWidth: 80,
          align: "center"
        },
        {
          title: "法定计量单位",
          key: "unit1",
          minWidth: 80,
          align: "center"
        },
        {
          title: "法定第二单位",
          key: "unit2",
          minWidth: 80,
          align: "center"
        },
        {
          title: "原产国(地区)",
          key: "countryCode",
          minWidth: 80,
          align: "center"
        },
        {
          title: "企业申报单价",
          key: "decPrice",
          minWidth: 100,
          align: "center"
        },
        {
          title: "企业申报总价",
          key: "decTotal",
          minWidth: 150,
          align: "center"
        },
        {
          title: "法定数量",
          key: "factor1",
          minWidth: 100,
          align: "center"
        },
        {
          title: "第二法定数量",
          key: "factor2",
          minWidth: 100,
          align: "center"
        },
        {
          title: "申报数量",
          key: "qty",
          minWidth: 80,
          align: "center"
        },
        {
          title: "币制",
          key: "curr",
          minWidth: 80,
          align: "center"
        }
      ],
      billColumns: [
        {
          title: "序号",
          key: "index",
          minWidth: 60,
          align: "center",
          type: "index"
        },
        {
          title: "清单号",
          key: "billNo",
          minWidth: 200,
          align: "center"
        },
        {
          title: "运单号",
          key: "mailNo",
          minWidth: 200,
          align: "center"
        },
        {
          title: "订单号",
          key: "merchantOrderNo",
          minWidth: 200,
          align: "center"
        }
      ]
    };
  },
  created() {
    this.heZhuOrderId = this.$route.params.id;
    this.fetch();
  },
  mounted() {
    this.heZhuOrderId = this.$route.params.id;
  },
  methods: {
    fetch() {
      this.loading = true;
      heZhuApi
        .load({
          heZhuOrderId: this.heZhuOrderId
        })
        .then(res => {
          console.log(res);
          this.info = res;
          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
        });
    }
  },
  watch: {
    $route(to, from) {
      if (to.name === "eCommerceHeZhuDetail") {
        this.heZhuOrderId = this.$route.params.id;
        this.fetch();
      }
    }
  }
};
</script>
